import _ from 'lodash';
import { ChannelType } from '../redux/types';
import { demoChannel, demoChannelEditor } from '../constants/demo-channel';

export function isVODChannel(channelData) {
  return channelData.channelType === ChannelType.Channel;
}

export function isYouTubeFeed(channelData) {
  return channelData.channelType === ChannelType.YoutubeFeed;
}

export function hasTags(channelData) {
  const tags = _.get(channelData, 'statsInfo.tags');
  return !_.isEmpty(tags);
}

export function hasVideos(channelData) {
  return channelData.videosCount > 0;
}

export function isDemoChannel(channelId) {
  return _.includes([demoChannel.id, demoChannelEditor.id], channelId);
}
